import WindowDimensions from "hooks/useDimensions";
import { useLocation } from "react-router-dom";
import MobileNav from "./MobileNav";
import st_nav from "./Nav.module.css";
import WebNav from "./WebNav";

const Nav = () => {
    const isWeb = WindowDimensions();

    const angel_link = "https://www.angelprotocol.io/"
    const angel_img = `/images/${isWeb ? "aplogo_white" : "angelwing"}.png`;

    return (
        <nav className={st_nav.nav}>
            <a href={angel_link} target="_blank">
                <img src={angel_img}/>
            </a>
            { isWeb && <WebNav/> }
            { !isWeb && <MobileNav/> }
        </nav>
    )
}

export default Nav;